import React, { useState } from 'react';
import { SylApi } from '@syllepsis/adapter';
import {
  // Config,
  BlockQuotePlugin,
  BoldPlugin,
  BulletListPlugin,
  // CodeBlockPlugin,
  FontSizePlugin,
  HrPlugin,
  ItalicPlugin,
  ListItemPlugin,
  SubPlugin,
  SupPlugin,
  OrderedListPlugin,
  StrikePlugin,
  UnderlinePlugin,
  ParagraphPlugin,
  HeaderPlugin,
  FormatClearPlugin,
  LetterSpacePlugin,
  UndoPlugin,
  RedoPlugin,
  AlignLeftPlugin,
  SpaceBeforePlugin,
  SpaceBothPlugin,
  SpaceAfterPlugin,
  LineHeightPlugin,
  LineIndentPlugin,
  FormatPainterPlugin,
  AlignCenterPlugin,
  AlignJustifyPlugin,
  AlignRightPlugin,
} from '@syllepsis/plugin-basic';
import { CodeBlockPlugin } from '@syllepsis/plugin-code-block';
import {
  // ToolbarInlineLoader,
  ToolbarLoader,
  ISylEditorProps,
} from '@syllepsis/editor';
// import {
//   DocImportPlugin, // 文档导入插件
// } from '@byted/syllepsis_plugins';
import {
  SylEditor,
  Toolbar,

  // AnchorUtil,
  // ImagePlugin,
  LinkPlugin,
  BackgroundPlugin,
  ColorPlugin,
  EmojiPlugin,
  // ImagePlugin,
  InlineImagePlugin,
  // VideoPlugin
} from '@syllepsis/access-react';
// import { ImagePlugin } from 'components/syl-editor/plugins/image';
// import { VideoPlugin } from 'components/syl-editor/plugins/video';
import { TablePlugin } from '@syllepsis/plugin-table';
import { Toast } from '@douyinfe/semi-ui';
import { VideoPlugin } from './video';
import { uploadService } from '@/api/Upload';
import usePostImageSet from '@/hooks/usePostImageSet';
// import { ToolbarInline } from '@syl-editor/react-syl-editor-v2/dist/lib/modules/toolbar/render/inline';

type Props = {
  getEditorInstance: (editor: SylApi) => void;
} & React.HTMLProps<HTMLDivElement>;

const locale = {
  header1: {
    tooltip: '一级标题',
  },
  header2: {
    tooltip: '二级标题',
  },
  header3: {
    tooltip: '三级标题',
  },

  background: {
    tooltip: '背景颜色',
  },
  color: {
    tooltip: '字体颜色',
  },

  undo: {
    tooltip: '撤销',
  },
  redo: {
    tooltip: '重做',
  },
  format_clear: {
    tooltip: '清除格式',
  },
  format_painter: {
    tooltip: '格式刷',
  },
  header: {
    tooltip: '多级标题',
  },
  block_quote: {
    tooltip: '引用',
  },
  bullet_list: {
    tooltip: '无序列表',
  },
  ordered_list: {
    tooltip: '有序列表',
  },
  code_block: {
    tooltip: '代码块',
  },
  image: {
    tooltip: '图片',
    placeholder: '请输入图片描述',
    left: '居左',
    center: '居中',
    right: '居右',
  },
  link: {
    tooltip: '链接',
    editLinkTitle: '修改链接',
    insertLinkTitle: '插入链接',
    textPlaceholder: '请输入链接文本',
    linkPlaceholder: '请输入链接地址',
    cancelText: '取消',
    okText: '确定',
  },
  video: {
    tooltip: '视频',
  },
  emoji: {
    tooltip: '表情',
  },
  hr: {
    tooltip: '分割线',
  },
  bold: {
    tooltip: '粗体',
  },
  italic: {
    tooltip: '斜体',
  },
  underline: {
    tooltip: '下划线',
  },
  strike: {
    tooltip: '删除线',
  },
  sub: {
    tooltip: '下标',
  },
  sup: {
    tooltip: '上标',
  },
  font_size: {
    tooltip: '字体大小',
  },
  anchor: {
    tooltip: '锚点',
  },
  align_left: {
    tooltip: '左对齐',
  },
  align_center: {
    tooltip: '居中对齐',
  },
  align_right: {
    tooltip: '右对齐',
  },
  align_justify: {
    tooltip: '等分对齐',
  },
};

export const EditorV2: React.FC<Props> = ({
  getEditorInstance,
  ...rest
}: Props) => {
  const { setUrlSet } = usePostImageSet();
  const [plugins] = useState([
    new FontSizePlugin({
      values: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
    }),
    new AlignLeftPlugin(),
    new AlignCenterPlugin(),
    new AlignRightPlugin(),
    new AlignJustifyPlugin(),
    new VideoPlugin(),
    new LinkPlugin(),
    new SubPlugin(),
    new SupPlugin(),
    new HeaderPlugin(),
    new BlockQuotePlugin(),
    new BoldPlugin(),
    new BulletListPlugin(),
    new FormatClearPlugin(),
    new HrPlugin(),
    new ItalicPlugin(),
    new OrderedListPlugin(),
    new StrikePlugin(),
    new UnderlinePlugin(),
    new ParagraphPlugin(),
    new LetterSpacePlugin(),
    new AlignLeftPlugin(),
    new BackgroundPlugin(),
    new ColorPlugin(),
    new TablePlugin(),
    new ListItemPlugin(),
    new EmojiPlugin(),
    new InlineImagePlugin({
      deleteFailedUpload: true,
      allowDomains: () => true,
      uploader: async (f, attrs) => {
        const resp = await fetch(attrs.src);
        const content = await resp.blob();
        const uploadFormData = new FormData();
        uploadFormData.append('file', content);
        const errorImageUrl =
          'http://p9-ma-forum-sign.byteimg.com/tos-cn-i-ho98pwquqr/bb3462428ca092061893828e16379dcc.png~tplv-ho98pwquqr-image.image';

        const res = await uploadService.uploadImage(uploadFormData);
        if (res.error) {
          Toast.error('图片上传失败');
          return {
            src: errorImageUrl,
          };
        } else {
          setUrlSet([
            {
              url: res.data.url || '',
              uri: res.data.uri || '',
            },
          ]);
          return res.data.url || '';
        }
      },
    }),
    // new CodeBlockPlugin(),
    // new FontFamilyPlugin(),
  ]);
  const [modules] = useState<ISylEditorProps['module']>({
    toolbar: {
      Ctor: ToolbarLoader,
      option: {
        Component: Toolbar,
        tooltips: {
          [RedoPlugin.getName()]: '重做',
          [UndoPlugin.getName()]: '撤销',
          [HeaderPlugin.getName()]: '标题',
          [BulletListPlugin.getName()]: '无序列表',
          [OrderedListPlugin.getName()]: '有序列表',
          [CodeBlockPlugin.getName()]: '代码块',
          [BlockQuotePlugin.getName()]: '引用',
          [BoldPlugin.getName()]: '加粗',
          [ItalicPlugin.getName()]: '斜体',
          [UnderlinePlugin.getName()]: '下划线',
          [StrikePlugin.getName()]: '删除线',
          [FontSizePlugin.getName()]: '字体大小',
          [LetterSpacePlugin.getName()]: '字间距',
          [BackgroundPlugin.getName()]: '背景色',
          [FormatPainterPlugin.getName()]: '格式刷',
          [FormatClearPlugin.getName()]: '清除格式',
          [ColorPlugin.getName()]: '颜色',
          [VideoPlugin.getName()]: '视频',
          [HrPlugin.getName()]: '分割线',
          [LinkPlugin.getName()]: '超链接',
          [SubPlugin.getName()]: '下标',
          [SupPlugin.getName()]: '上标',
          [EmojiPlugin.getName()]: 'emoji 表情',
          [TablePlugin.getName()]: '表格',
          [SpaceBeforePlugin.getName()]: '段前距',
          [SpaceAfterPlugin.getName()]: '段后距',
          [SpaceBothPlugin.getName()]: '两端缩进',
          [LineHeightPlugin.getName()]: '行高',
          [LineIndentPlugin.getName()]: '首行缩进',
        },
        tools: [
          UndoPlugin.getName(),
          RedoPlugin.getName(),
          HeaderPlugin.getName(),
          BulletListPlugin.getName(),
          OrderedListPlugin.getName(),
          CodeBlockPlugin.getName(),
          BlockQuotePlugin.getName(),
          BoldPlugin.getName(),
          ItalicPlugin.getName(),
          UnderlinePlugin.getName(),
          StrikePlugin.getName(),
          FontSizePlugin.getName(),
          LetterSpacePlugin.getName(),
          BackgroundPlugin.getName(),
          FormatClearPlugin.getName(),
          FormatPainterPlugin.getName(),
          ColorPlugin.getName(),
          VideoPlugin.getName(),
          HrPlugin.getName(),
          LinkPlugin.getName(),
          SubPlugin.getName(),
          SupPlugin.getName(),
          EmojiPlugin.getName(),
          [
            AlignLeftPlugin.getName(),
            AlignCenterPlugin.getName(),
            AlignRightPlugin.getName(),
            AlignJustifyPlugin.getName(),
          ],
          SpaceBeforePlugin.getName(),
          SpaceAfterPlugin.getName(),
          SpaceBothPlugin.getName(),
          LineHeightPlugin.getName(),
          LineIndentPlugin.getName(),
          UndoPlugin.getName(),
          RedoPlugin.getName(),
          InlineImagePlugin.getName(),
          FontSizePlugin.getName(),
          TablePlugin.getName(),
          // 'format_clear',
          // 'format_painter',
          // '|',
          // 'header',
          // 'block_quote',
          // 'bullet_list',
          // 'ordered_list',
          // 'code_block',
          // 'link',
          // 'video',
          // 'audio',
          // 'emoji',
          // 'hr',
          // 'bold',
          // 'italic',
          // 'underline',
          // 'strike',
          // 'sub',
          // 'sup',
          // 'font_size',
          // 'anchor',
          // 'align_left',
          // 'align_center',
          // 'align_right',
          // 'align_justify',
          // 'space_before',
          // 'space_after',
          // 'space_both',
          // 'line_height',
          // 'line_indent',
          // 'background',
          // 'color',
        ],
      },
    },
  });

  // const { defaultValue, placeholder, resetValue, onChange } = props;
  // const editorRef = useRef<SylEditor>(null);
  // const [adapter, setAdapter] = useState<SylApi>();
  // useEffect(() => {
  //   adapter?.setHTML(defaultValue || '');
  // }, [defaultValue, adapter]);

  // useEffect(() => {
  //   if (typeof resetValue === 'undefined') {
  //     return;
  //   }
  //   adapter?.setHTML('');
  // }, [resetValue]);

  // const traceContentChange = (editor: SylApi) => {
  //   editor.on(EventChannel.LocalEvent.TEXT_CHANGED, () => {
  //     // console.log('内容发生变化，可通过调用 adapter.getHTML() 获取内容', editor?.getHTML());

  //     const html = editor?.getHTML() || '';
  //     const text = editor?.getText() || '';
  //     // console.log(html);

  //     if (onChange) {
  //       onChange && onChange(html, text);
  //     }
  //   });
  // };

  return (
    <div style={{ border: '1px solid #e5e5e5' }} {...rest}>
      <SylEditor
        // ref={editorRef}
        locale={locale}
        // placeholder={placeholder}
        // getAdapter={getAdapter}
        // config={config}
        plugins={plugins}
        module={modules}
        getEditor={editor => {
          getEditorInstance(editor);
        }}
      />
    </div>
  );
};

export default EditorV2;
